export default __webpack_public_path__ + "static/media/Snd_K_Starts.e9b30017.mp3";